import { Directive, Input, TemplateRef, inject } from '@angular/core';

/**
 * mbs-table-nav custom content
 */
@Directive({
  selector: '[mbsTableNavContent]'
})
export class TableNavContentDirective {
  template = inject<TemplateRef<any>>(TemplateRef);

  @Input('mbsTableNavContent') context: any;
}
